// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"sectionPanel_linkItem__pGk5v","linkContent":"sectionPanel_linkContent__qrV32"};